import _ from 'lodash'
export const loadState = () => {
    try {
        const serializedState = localStorage.getItem('state');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

export const saveState = (state) => {
    try {
        const keys = _.keys(state);
        const filteredKeys = _.filter(keys,(k)=> k !== 'systemError' && k !== 'loading' && k !=="error");
        const filteredState = _.pick(state, filteredKeys);
        const serializedState = JSON.stringify(filteredState);
        localStorage.setItem('state', serializedState);
    } catch (err) {
        // Ignore write errors.
    }
};